export default "__VITE_ASSET__UD2xzQdU__"